import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NOTIFICATIONS_DRAWER_FEATURE_KEY, NotificationsDrawerState } from './notifications-drawer.state';

const selectNotificationsDrawerState = createFeatureSelector<NotificationsDrawerState>(
  NOTIFICATIONS_DRAWER_FEATURE_KEY
);

export const selectCategories = createSelector(selectNotificationsDrawerState, state => state.categories);

export const selectTotalCount = createSelector(selectNotificationsDrawerState, state => state.totalCount);

export const selectUnreadCount = createSelector(selectNotificationsDrawerState, state => state.unreadCount);

export const selectLoading = createSelector(selectNotificationsDrawerState, state => state.loading);

export const selectError = createSelector(selectNotificationsDrawerState, state => state.error);

export const selectTypePageStates = createSelector(selectNotificationsDrawerState, state => state.typePageStates);

export const selectTypePageState = (typeCode: string) =>
  createSelector(selectNotificationsDrawerState, state => state.typePageStates[typeCode]);

export const selectExpandedSections = createSelector(selectNotificationsDrawerState, state => state.expandedSections);

export const selectIsSectionExpanded = (typeCode: string) =>
  createSelector(selectNotificationsDrawerState, state => !!state.expandedSections[typeCode]);

/** Combines typePageStates and categories so the refill effect can inspect
 *  both the needsRefill flag and the current notifications array length. */
export const selectRefillContext = createSelector(selectNotificationsDrawerState, state => ({
  typePageStates: state.typePageStates,
  categories: state.categories
}));

export const selectPendingDeletes = createSelector(selectNotificationsDrawerState, state => state.pendingDeletes);
